import { useMemo } from "react";

import { AuditLogEvents, IAuditLogMetadata } from "@ryde/shared";

export const useAuditLogEventClassNames = () => {
  const getEventClassNames = useMemo(
    () =>
      ({
        baseClassName,
        eventName,
        metadata,
      }: {
        baseClassName: string;
        eventName: AuditLogEvents;
        metadata?: IAuditLogMetadata;
      }) => ({
        [`${baseClassName}--created`]:
          eventName === AuditLogEvents.EntityCreated,
        [`${baseClassName}--deleted`]:
          eventName === AuditLogEvents.EntityDeleted,
        [`${baseClassName}--updated`]:
          eventName === AuditLogEvents.EntityUpdated,
        [`${baseClassName}--syncer-push`]: metadata?.isPushToSyncer === true,
      }),
    [],
  );

  return { getEventClassNames };
};
